import styles from "./../buttons.module.scss"
import React from "react";
import classNames from "classnames";
import { getBaseClassName } from "./Button";
import { ExternalLinkIcon as ArrowIcon } from "@netapp/bxp-style/react-icons/Navigation";
import Tooltip from "./Tooltip";

let trackExternalLink = null;

export const setExternalLinkTracker = ({ trackExternalLink: _trackExternalLink }) => {
    trackExternalLink = _trackExternalLink;
}

export const ExternalLink = ({ children, className, style, color, type, variant, large, disabled, tooltip, to, trackCategory, trackLabel, href, title, newTab = true, includeArrow, arrowStyle, onClick, dataTestId, ...rest }) => {
    const baseClassName = getBaseClassName({ type, color, variant })

    const _className = classNames(baseClassName, className, { [styles.large]: large });
    return <a
        href={disabled ? "" : href}
        disabled={disabled}
        onClick={disabled ? e => {
            e.preventDefault()
        } : (e) => {
            if(trackCategory){
                trackExternalLink({ category: trackCategory, label: trackLabel || href });
            }

            if(onClick){
                onClick(e);
            }
        }}
        className={_className}
        {...rest}
        title={title}
        style={style}
        target={newTab ? "_blank" : undefined}
        rel={newTab ? "noopener noreferrer" : undefined}
        data-testid={dataTestId}>
        {children}
        {includeArrow && <ArrowIcon style={{ margin: "3px 0 0 8px", width: 13.5, height: 13.5, ...arrowStyle }}/>}
        {tooltip && <Tooltip>{tooltip}</Tooltip>}
    </a>
}